import { Dispatch } from 'redux';
import { api } from '../../../App';
import { refreshUser } from './refreshUser';

export const logInWithCode = (code: string) => async (dispatch: Dispatch) => {
  await api.enrollment.apiEnrollVerifyPost({ otp: code });
  await refreshUser()(dispatch);
};
